import { Component, inject } from '@angular/core';
import { Country } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { CountryService } from '../../../../shared/services/country.service';

@Component({
  selector: 'app-formly-country-code-dropdown',
  template: '',
  providers: [CountryService],
  standalone: true
})
export class FormlyCountryCodeDropdownComponent extends GenericBaseModelDropDown<Country> {

  constructor() {
    super(inject(CountryService), "Country");
  }

}
